export const formatCompactNumber = (value: number): string => {
	const absoluteValue = Math.abs(value);
	const sign = value < 0 ? '-' : '';

	if (absoluteValue >= 1_000_000_000) {
		const compact = (absoluteValue / 1_000_000_000)
			.toFixed(1)
			.replace(/\.0$/, '');
		return `${sign}${compact}B`;
	}

	if (absoluteValue >= 1_000_000) {
		const compact = (absoluteValue / 1_000_000).toFixed(1).replace(/\.0$/, '');
		return `${sign}${compact}M`;
	}

	if (absoluteValue >= 1_000) {
		const compact = (absoluteValue / 1_000).toFixed(1).replace(/\.0$/, '');
		return `${sign}${compact}K`;
	}

	return value.toLocaleString();
};
